import {
  Component,
  OnInit,
  ViewEncapsulation,
  Input,
  Output,
  EventEmitter,
} from "@angular/core";
import { FormGroup, FormControl } from "@angular/forms";

@Component({
  selector: "app-togglebutton",
  templateUrl: "./togglebutton.component.html",
  styleUrls: ["./togglebutton.component.css"],
})
export class TogglebuttonComponent implements OnInit {
  @Input() group: FormGroup;
  @Input() type: string;
  @Input() description: string;
  @Input() class: string;
  @Input() data: string;
  @Input() checked: boolean;
  @Output() callFunction = new EventEmitter();

  constructor() {}

  ngOnInit(): void {
    this.group = new FormGroup({
      firstName: new FormControl(),
    });
  }
  toggle(event) {
    this.callFunction.emit(event);
    // console.log(event)
  }
}
